/* qeslint-disable */
// q@ts-nocheck

export enum DistanceUnits {
    METERS = "METERS",
    CENTIMETERS = "CENTIMETERS",
    KILOMETERS = "KILOMETERS",
    FEET = "FEET",
    US_SURVEY_FEET = "US_SURVEY_FEET",
    INCHES = "INCHES",
    YARDS = "YARDS",
    MILES = "MILES"
}
